import React from 'react';
import './Education1.css'
const Education1 = () => {
    return (
        <div className='qualification section' id='Education'>
            <h2 className='qua_title'>Qualifications</h2>
        <div className='qualifications_container'>
            <div className='qualification_tabs'>
                    <i className='uil uil-graduation-cap gradca'></i>
            </div>
            <div className='qualification_sections'>
                <div className='qualification_content'>
                    <div className='qualification_data'>
                    <div className='qualda'>
                            <h3 className='qualification_title'>Bachelor Of Technology</h3>
                            <p className='Stream'>Computer Science and Engineering</p>
                            <span className='qualification_inst'>Adikavi Nannaya University</span>
                            <div className='qualification_calender'>
                                <i className='uil uil-calendar-alt calendar'></i>2018-2022
                            </div>
                    </div>
                    <div>
                        <span className='qualification_rounder'></span>
                        <div className='qualification_line'></div>
                    </div>
                    </div>
        
                    <div className='qualification_data'>
                        <div></div>
                        <div>
                    
                    <span className='qualification_rounder'></span>
                    <span className='qualification_line'></span>  
                    </div>
                    <div className='qualda'>
                            <h3 className='qualification_title'>Intermediate</h3>
                            <p className='Stream'>M.P.C</p>
                            <span className='qualification_inst'>Andhra Pradesh Board Of Intermediate Education</span>
                            <div className='qualification_calender'>
                                <i className='uil uil-calendar-alt calendar'></i>2016-2018
                            </div>
                    </div>
                   
                    </div>
                    <div className='qualification_data'>
                    <div className='qualda'>
                            <h3 className='qualification_title'>Seondary Education</h3>
                            <p className='Stream'></p>
                            <p className='qualification_inst'>Andhra Pradesh Board Of Seondary Education</p>
                            <div className='qualification_calender'>
                                <i className='uil uil-calendar-alt calendar'></i>2016
                            </div>
                    </div>
                    <div>
                        <span className='qualification_rounder'></span>
                        
                    </div>
                    </div>

                </div>
            </div>
        </div>
        </div>
    );
};

export default Education1;